import Swal from "sweetalert2";

function confirmationPopup(dynamicValue) {
  return Swal.fire({
    html: `<h4 style="font-size:1.2rem;">${dynamicValue}</h4>`,
    confirmButtonColor: "#1273EB",
    showDenyButton: true,
    confirmButtonText: "Yes",
    denyButtonText: `No`,
    denyButtonColor: "#858585"
  });
}

export default confirmationPopup;
